import * as React from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, Modal } from "@material-ui/core";
import { AppContext, ApplicationContext } from "../../context/Contexts";
import { CreateEInvoiceRequest, DeclineMavoVehicleOrderRequest, MavoVehicleCreateInvoiceRequestDto, MavoVehicleCreateNoticeRequestDto, MavoVehicleOrderRCICloseRequest } from '../../interfaces/Vehicle';
import { CreateAcquisitionCaseTemplateEnum, InvoiceTypeCodeEnum, MavoOrderStatusCodeEnum, MavoVehicleProvenanceType, ReportTypeCode } from '../../helpers/Constants';
import { withSnackbar } from 'notistack';
import {  ApplicationState } from '../../store';
import { connect } from 'react-redux';
import { IMavoOrdersButtonsProps, MavoOrderButtonsProps } from '../cases/vehicleDetails/IMavoOrdersButtonsProps';
import FileSaver from 'file-saver';
import { AcquisitionCaseRequest, CreateAcquisitionCaseRequest } from '../../interfaces/Case';

interface IOrdersButtonsState {
  isLoading: boolean;
  executing: boolean;
  orderConfirmationLoading: boolean;
  cancelOrderLoading: boolean;
  orderRefuseLoading: boolean;
  printPaymentNoticeLoading: boolean;
  generateInvoiceLoading: boolean;
  rciCloseOrderLoading: boolean;
  isAcquisitionCaseOpen: boolean;
  isAcquisitionCaseLoading: boolean;
}

class OrdersButtons extends React.PureComponent<
  IMavoOrdersButtonsProps,
  IOrdersButtonsState
> {

  state = {
    isLoading: false,
    executing: false,
    orderConfirmationLoading: false,
    cancelOrderLoading: false,
    orderRefuseLoading: false,
    printPaymentNoticeLoading: false,
    generateInvoiceLoading: false,
    rciCloseOrderLoading: false,
    isAcquisitionCaseOpen: false, 
    isAcquisitionCaseLoading: false
  } as IOrdersButtonsState;

  private cbContext!: AppContext;
  static contextType = ApplicationContext;

  handleOrderConfirm = async () => {
    if (!this.props.selectedOrder?.orderStatus) return;
    if (this.props.selectedOrder?.orderStatus.code === MavoOrderStatusCodeEnum.CONFIRMAT.toString()) {
      this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('ORDER_CONFIRM_ERR_MSG', 'Nu puteti confirma o comanda deja confirmata!'), {
        variant: 'warning' 
      });
      return;
    }
    if (this.props.selectedOrder?.orderStatus.code === MavoOrderStatusCodeEnum.TRANSMIS.toString()) {
      try {
        this.setState({ orderConfirmationLoading: true });

        const request = {
          mavoVehicleOrderId: this.props.selectedOrder.id,
          organizationId: this.props.selectedOrder.organizationId ?? null
        } as MavoVehicleCreateNoticeRequestDto;

        await this.cbContext.vehicleService.ConfirmMavoVehicleOrder(ReportTypeCode.RENAULT_AVIZ_PLATA, request);

        this.props.loadOrders(this.props.page, this.props.pageSize);

        this.setState({ orderConfirmationLoading: false });

        this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch {
        this.setState({ executing: false, orderConfirmationLoading: false });
        this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    }
  }
  
  handleCancelConfirmation = async () => {
    if (!this.props.selectedOrder?.orderStatus) return;

    if (this.props.selectedOrder?.orderStatus.code === MavoOrderStatusCodeEnum.TRANSMIS.toString()) {
      this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('ORDER_CANCEL_CONFIRM_ERR_MSG', 'Nu a fost generat Aviz de Plata!'), {
        variant: 'warning'
      });
      return;
    }

    try {
      this.setState({ cancelOrderLoading: true });
      const request = {
          mavoVehicleOrderId: this.props.selectedOrder.id,
          organizationId: this.props.selectedOrder.organizationId ?? null
        } as MavoVehicleCreateNoticeRequestDto;
        
      await this.cbContext.vehicleService.CancelNoticeMavoVehicle(ReportTypeCode.RENAULT_AVIZ_PLATA, request);

      this.props.loadOrders(this.props.page, this.props.pageSize);

      this.setState({ cancelOrderLoading: false });

      this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch {
      this.setState({ executing: false, cancelOrderLoading: false });

      this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  
  }

  handleOrderRefuse = async () => {
    if (!this.props.selectedOrder?.orderStatus) return;
    if (this.props.selectedOrder?.orderStatus.code === MavoOrderStatusCodeEnum.CONFIRMAT.toString()) {
      this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('ORDER_REFUSE_ERR_MSG', 'Vehicul in curs de facturare!'), {
        variant: 'warning'
      });
      return;
    }
    try {
      this.setState({ orderRefuseLoading: true });

      const request = {
        mavoVehicleOrderId: this.props.selectedOrder.id
      } as DeclineMavoVehicleOrderRequest;

      await this.cbContext.vehicleService.DeclineMavoVehicleOrder(request);

      this.props.loadOrders(this.props.page, this.props.pageSize);

      this.setState({ orderRefuseLoading: false });

      this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch {
      this.setState({ executing: false, orderRefuseLoading: false });
      this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  }

  handlePrintPaymentNotice = async () => {
    if (!this.props.selectedOrder?.orderStatus) return;
    if (this.props.selectedOrder?.orderStatus.code === MavoOrderStatusCodeEnum.TRANSMIS.toString()) {
      this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('ORDER_PRINT_PAYMENT_NOTICE_ERR_MSG', 'Vehicul fara Aviz de Plata !'), {
        variant: 'warning'
      });
      return;
    }

    try {
      this.setState({ printPaymentNoticeLoading: true });

      const fileBlob = await this.cbContext.vehicleService.PrintMavoVehicleNotice(this.props.selectedOrder.id);

      this.setState({ printPaymentNoticeLoading: false });

      const file = new File([fileBlob], this.cbContext.translatorService.Tranlate('PRINT_NOTICE_NAME', 'Avizare plata bancara') + '.pdf', { type: 'application/pdf' });
      
      FileSaver.saveAs(fileBlob, "AvizarePlataBancara" + '.pdf');

      const url = URL.createObjectURL(file);
      window.open(url, '_blank');
    } catch {
      this.setState({ executing: false, printPaymentNoticeLoading: false });

      this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  }

  handleInvoiceGenerate = async () => {
    if (!this.props.selectedOrder?.orderStatus) return;
    if (this.props.selectedOrder?.orderStatus.code === MavoOrderStatusCodeEnum.TRANSMIS.toString()) {
      this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('ORDER_PRINT_PAYMENT_NOTICE_ERR_MSG', 'Vehicul fara Aviz de Plata !'), {
        variant: 'warning'
      });
      return;
    }

    try {
      this.setState({ generateInvoiceLoading: true });

      const request = {
        mavoVehicleOrderId: this.props.selectedOrder.id,
        organizationId: this.props.selectedOrder.organizationId ?? null
      } as MavoVehicleCreateInvoiceRequestDto;
      const response = await this.cbContext.vehicleService.GenerateInvoiceReport(ReportTypeCode.RENAULT_FACTURA_LIVRARE, request);

      if (response.existingValidInvoice) {
        this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('ORDER_VALID_GENERATE_INVOICE_ERR_MSG', 'Factura valida existenta!'), {
          variant: 'warning'
        });
        this.setState({ generateInvoiceLoading: false });
        return;
      }

      const eInvoiceResponse = await this.cbContext.vehicleService.CreateEInvoice({
        orderId: this.props.selectedOrder.id,
        invoiceId: response.id,
        invoiceTypeCode: InvoiceTypeCodeEnum.FACTURA.toString()
      } as CreateEInvoiceRequest);
      if (eInvoiceResponse && eInvoiceResponse.statusMessage) {
        this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate(eInvoiceResponse.statusMessage, eInvoiceResponse.statusMessage), {
          variant: 'warning'
        });
      }

      this.props.loadOrders(this.props.page, this.props.pageSize);

      this.setState({ generateInvoiceLoading: false });

      this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch {
      this.setState({ executing: false, generateInvoiceLoading: false });

      this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  }

  handleRCICloseOrder = async () => {
    if (!this.props.selectedOrder) return;

    try {
      this.setState({ rciCloseOrderLoading: true });

      const request = {
        mavoVehicleOrderId: this.props.selectedOrder.id
      } as MavoVehicleOrderRCICloseRequest;

      await this.cbContext.vehicleService.CloseMavoVehicleOrderRCI(request);

      this.props.loadOrders(this.props.page, this.props.pageSize);

      this.setState({ rciCloseOrderLoading: false });

      this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch {
      this.setState({ executing: false, rciCloseOrderLoading: false });

      this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  }

  orderButtonDisabled = () => {
    if (this.state.orderConfirmationLoading || this.state.cancelOrderLoading || this.state.orderRefuseLoading || this.state.printPaymentNoticeLoading || this.state.generateInvoiceLoading || this.state.rciCloseOrderLoading) {
      return true;
    }

    if (this.props.selectedOrder && this.props.selectedOrder.mavoVehicle!.provenance!.type === MavoVehicleProvenanceType.DVS) {
      return false;
    }

    return true;
  }

  rciButtonDisabled = () => {
    if (this.state.orderConfirmationLoading || this.state.cancelOrderLoading || this.state.orderRefuseLoading || this.state.printPaymentNoticeLoading || this.state.generateInvoiceLoading || this.state.rciCloseOrderLoading) {
      return true;
    }

    if (this.props.selectedOrder && this.props.selectedOrder.mavoVehicle!.provenance!.type === MavoVehicleProvenanceType.RCI) {
      return false;
    }

    return true;
  }

  handleOpenAcquisitionCaseConfirmationDialog = async () => {
    if (!this.props.acquisitionWorkflow) {
      this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('MAVO_VEHICLE_ACQUISITION_CASE_NOT_FOUND', 'Nu s-a gasit fluxul de achizitie!'), {
        variant: 'warning'
      });
      return;
    }

    if (!this.props.selectedOrder) {
      this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('PLEASE_SELECT_VEHICLE', 'Va rugam sa selectati un vehicul!'), {
        variant: 'warning'
      });
      return;
    }

    if (!this.props.selectedOrder.organizationId) {
      this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('PLEASE_SELECT_ORDER_OF_DEALER', 'Va rugam sa selectati o comanda pentru un dealer!'), {
        variant: 'warning'
      });
      return;
    }

    const request = {
      vin: this.props.selectedOrder.mavoVehicle.vin,
      dealerId: this.props.selectedOrder.organizationId ?? null,
    } as AcquisitionCaseRequest;
    const vinAquisitionCases = await this.cbContext.caseService.GetAcquisitionCases(request);
    if (vinAquisitionCases.length > 0) {
      this.props.enqueueSnackbar(
        (this.cbContext.translatorService.Tranlate(
          'ALREADY_AQUISITION_CASE',
          'Exista deja un dosar de achizitie deschis, va rugam sa verificati!'
        ) + '\n' +
        (vinAquisitionCases.length == 1 ? this.cbContext.translatorService.Tranlate('CASES_ID_LABEL', 'Id-ul dosarului este: ') : this.cbContext.translatorService.Tranlate('CASES_IDS', 'Id-urile dosarelor sunt: ')) +
        vinAquisitionCases.map((item) => item.id).join(', ')),
        {
          variant: 'warning',
          style: { whiteSpace: 'pre-line' },
          autoHideDuration: 6000
        }
      );
      return;
    }

    this.setState({
      isAcquisitionCaseOpen: true
    });
  };

  handleCreateAcquisitionCase = async () => {
    if (!this.props.acquisitionWorkflow) {
      this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('MAVO_VEHICLE_ACQUISITION_CASE_NOT_FOUND', 'Nu s-a gasit fluxul de achizitie!'), {
        variant: 'warning'
      });
      return;
    }

    if (!this.props.selectedOrder) {
      this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('PLEASE_SELECT_VEHICLE', 'Va rugam sa selectati un vehicul!'), {
        variant: 'warning'
      });
      return;
    }

    if (!this.props.selectedOrder.organizationId) {
      this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('PLEASE_SELECT_ORDER_OF_DEALER', 'Va rugam sa selectati o comanda pentru un dealer!'), {
        variant: 'warning'
      });
      return;
    }

    try {
      this.setState({
        isAcquisitionCaseLoading: true
      });

      const request = {
        workflowId: this.props.acquisitionWorkflow.id,
        dealerId: this.props.selectedOrder.organizationId ?? null,
        vehicleId: this.props.selectedOrder.mavoVehicle.id,
        template: CreateAcquisitionCaseTemplateEnum.NEW_ACQUISITION_CASE
      } as CreateAcquisitionCaseRequest;
      const createdCase = await this.cbContext.caseService.CreateAcquisitionCase(request);
      
      this.setState({
        isAcquisitionCaseLoading: false,
        isAcquisitionCaseOpen: false
      });
      this.props.history.push('/cases/' + createdCase.id);     
      this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (err: any) {
      this.setState({
        isAcquisitionCaseLoading: false
      });
      this.props.enqueueSnackbar(this.cbContext.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  }

  handleAcquisitionCaseCloseModal = () => {
    this.setState({
      isAcquisitionCaseOpen: false
    });
  };

  disabledCreateAcquisitionCase = () => {
    if (!this.props.acquisitionWorkflow || !this.props.selectedOrder || !this.props.selectedOrder.organizationId) {
      return true;
    }
    return false;
  }

  render() {
    this.cbContext = this.context as AppContext;

    return (
      <div className="row m-0 mt-3">
        <div className='mb-3 mr-2'>
          <Button
            variant="contained"
            color="secondary"
            type="submit"
            disabled={this.orderButtonDisabled()}
            onClick={this.handleOrderConfirm}
          >
            {this.state.orderConfirmationLoading && (
              <CircularProgress
                size={16}
                style={{ marginRight: 5 }}
              />
            )}
            {this.cbContext.translatorService.Tranlate(
              'MAVO_ORDER_CONFIRM_ORDER',
              'Confirma comanda'
            )}
          </Button>
        </div>
        <div className='mb-3 mr-2'>
          <Button
            variant="contained"
            color="secondary"
            type="submit"
            disabled={this.orderButtonDisabled()}
            onClick={this.handleCancelConfirmation}
          >
            {this.state.cancelOrderLoading && (
                <CircularProgress
                size={16}
                style={{ marginRight: 5 }}
              />
            )}
            {this.cbContext.translatorService.Tranlate(
              'MAVO_ORDER_CANCEL_ORDER_CONFIRMATION',
              'Anuleaza confirmare comanda'
            )}
          </Button>
        </div>
        <div className='mb-3 mr-2'>
          <Button
            variant="contained"
            color="secondary"
            type="submit"
            disabled={!this.props.selectedOrder || this.state.orderRefuseLoading}
            onClick={this.handleOrderRefuse}
          >
            {this.state.orderRefuseLoading && (
              <CircularProgress
                size={20}
                style={{ marginRight: 8 }}
              />
            )}
            {this.cbContext.translatorService.Tranlate(
              'MAVO_ORDER_REFUSE_ORDER',
              'Refuza comanda'
            )}
          </Button>
        </div>
        <div className='mb-3 mr-2'>
          <Button
            variant="contained"
            color="secondary"
            type="submit"
            disabled={this.orderButtonDisabled()}
            onClick={this.handlePrintPaymentNotice}
          >
           {this.state.printPaymentNoticeLoading && (
              <CircularProgress
                size={20}
                style={{ marginRight: 8 }}
              />
            )}
            {this.cbContext.translatorService.Tranlate(
              'MAVO_ORDER_PRINT_PAYMENT_ORDER',
              'Tiparire Aviz de Plata'
            )}
          </Button>
        </div>
        <div className='mb-3 mr-2'>
          <Button
            variant="contained"
            color="secondary"
            type="submit"
            disabled={this.orderButtonDisabled()}
            onClick={this.handleInvoiceGenerate}
          >
            {this.state.generateInvoiceLoading && (
              <CircularProgress
                size={20}
                style={{ marginRight: 8 }}
              />
            )}
            {this.cbContext.translatorService.Tranlate(
              'MAVO_ORDER_GENERATE_INVOICE',
              'Generare factura'
            )}
          </Button>
        </div>
        <div className='mb-3 mr-2'>
          <Button
            variant="contained"
            color="secondary"
            type="submit"
            disabled={this.rciButtonDisabled()}
            onClick={this.handleRCICloseOrder}   
          >
           {this.state.rciCloseOrderLoading && (
              <CircularProgress
                size={20}
                style={{ marginRight: 8 }}
              />
            )}
            {this.cbContext.translatorService.Tranlate(
              'MAVO_ORDER_CLOSE_RCI_ORDER',
              'Inchidere comanda RCI'
            )}
          </Button>
        </div>
        {this.props.acquisitionWorkflow ? (
          <div className='mb-3 mr-2'>
            <Button
              variant="contained"
              color="secondary"
              type="submit"
              onClick={this.handleOpenAcquisitionCaseConfirmationDialog}
              disabled={this.disabledCreateAcquisitionCase()}
            >
              {this.cbContext.translatorService.Tranlate(
                'MAVO_VEHICLE_ACQUISITION_CREATE_CASE',
                'Muta pe flux achizitie'
              )}
            </Button>
          </div>
        ) : ''}
        {this.state.isAcquisitionCaseOpen ? (
          <Modal open={this.state.isAcquisitionCaseOpen} onClose={this.handleAcquisitionCaseCloseModal}>
            <Dialog open={this.state.isAcquisitionCaseOpen} onClose={this.handleAcquisitionCaseCloseModal}>
              <DialogContent>
                <DialogContentText style={{ color: 'rgba(0, 0, 0, 0.87)' }}>
                  {`${this.cbContext.translatorService.Tranlate(
                    'MAVO_VEHICLE_ACQUISITION_CASE_CONFIRMATION_MESSAGE_FIRST',
                    'Doriti sa mutati vehiculul'
                  )} `}
                  <b>{` ${this.props.selectedOrder?.mavoVehicle?.vin ?? ""}`}</b>
                  {` ${this.cbContext.translatorService.Tranlate(
                    'MAVO_VEHICLE_ACQUISITION_CASE_CONFIRMATION_MESSAGE_SECOND',
                    'pe fluxul de achizitii pentru dealerul'
                  )} `}
                  <b>{` ${this.props.selectedOrder?.organization?.name ?? ""}`}</b>
                  ?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="outlined"
                  color="primary"
                  autoFocus
                  onClick={this.handleCreateAcquisitionCase}
                  disabled={this.state.isAcquisitionCaseLoading}
                >
                  {this.state.isAcquisitionCaseLoading && (
                    <CircularProgress
                      size={16}
                      style={{ marginRight: 5 }}
                    />
                  )}
                  {this.cbContext.translatorService.Tranlate('VEHICLE_SEARCH_FORM_VEHICLE_YES', 'Da')}
                </Button>
                <Button  
                  variant="outlined"
                  color="primary"
                  onClick={this.handleAcquisitionCaseCloseModal}
                  disabled={this.state.isAcquisitionCaseLoading}
                >
                  {this.cbContext.translatorService.Tranlate('VEHICLE_SEARCH_FORM_VEHICLE_NO', 'Nu')}
                </Button>
              </DialogActions>
            </Dialog>
          </Modal>
        ): ''}
      </div>
    );
  }
}

export default connect(
  (
    state: ApplicationState,
    ownProps: MavoOrderButtonsProps
  ) => ({
    appState: state.app,
    ...ownProps
  })
)(withSnackbar(OrdersButtons as any));
